import React from 'react';
import AppHeader from '../../components/header/header';
import DataTable from '../../components/dataTable';

import { connect } from "react-redux";
import { UsersState } from '../../store/users/types';
import { AppState } from '../../store';
import { loadUsers, loadExternal } from '../../store/users/actions';
import { withRouter } from 'react-router';
import { HashLoader } from "react-spinners";
import { NavLink as Link } from 'react-router-dom';
import { Tabs, AppBar, Tab, Box, Typography, Checkbox, FormControlLabel } from '@material-ui/core';

const cols = [{
    fieldName: "Email",
    fieldValue: "email",
    fieldType: 'string'
}, {
    fieldName: "Status",
    fieldValue: "UserStatus",
    fieldType: 'string' 
}];

const spinnerStyle = `
    margin: 100px auto;
`

interface UsersInterfaceProps {
    users: UsersState,
    loadUsers: typeof loadUsers,
    loadExternal: typeof loadExternal,
    history: any
}


interface TabPanelProps {
    children?: React.ReactNode;
    index: any;
    value: any;
  }
  

function TabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;
  
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box p={3}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }
  

class Users extends React.Component<UsersInterfaceProps> {
    state = {
        selectedTab: 0,
        showInactive:false
    }
    
    public componentDidMount():void {
        this.props.loadUsers();
    }

    public edit(username: string): void {
        this.props.history.push(`/user/${username}`);
    }
    
    public editExternal(username: string): void {
        this.props.history.push(`/external/${username}`);
    }

    public loadExternal() {
        
    }

    public changeTab(e, num) {
        switch(num) {
            case 0:
                this.props.loadUsers();
            break;

            case 1:
                this.props.loadExternal();
            break;
        }
        this.setState({selectedTab: num})
    }
    
    public render(): JSX.Element {
        return (
            <div>
                <AppHeader></AppHeader>
                <AppBar position="static">
                    <Tabs value={this.state.selectedTab} onChange={this.changeTab.bind(this)} aria-label="simple tabs example">
                        <Tab label="Internal Users" />
                        <Tab label="External Users" />
                    </Tabs>
                </AppBar>

                <TabPanel value={this.state.selectedTab} index={0}>
                    <HashLoader
                                css={spinnerStyle}
                                size={100}
                                color={"#297DAC"}
                                loading={this.props.users.loading} />
                    {!this.props.users.loading ?
                        <section>
                            <div className="page__title">
                                <h1 className="section__name">Internal Users</h1>
                                <FormControlLabel
                                    className="inactive__check"
                                    control={<Checkbox checked={this.state.showInactive} onChange={()=>this.setState({showInactive: !this.state.showInactive})} name="showInactive" />}
                                    label="Show inactive"
                                />
                                <Link className="create__btn" to="/user/create">Add Internal User</Link>
                            </div>

                            <DataTable 
                                cols={cols} 
                                rows={this.props.users.users.filter(u=>u.Enabled || (!u.Enabled && this.state.showInactive))}
                                rowClickAction={user => this.edit(user.Username)}
                            ></DataTable>
                        </section>
                    : null}
                </TabPanel>

                <TabPanel value={this.state.selectedTab} index={1}>
                    <HashLoader
                                css={spinnerStyle}
                                size={100}
                                color={"#297DAC"}
                                loading={this.props.users.loading} />
                    {!this.props.users.loading ?
                        <section>
                            <div className="page__title">
                                <h1 className="section__name">External Users</h1>
                                <FormControlLabel
                                    className="inactive__check"
                                    control={<Checkbox checked={this.state.showInactive} onChange={()=>this.setState({showInactive: !this.state.showInactive})} name="showInactive" />}
                                    label="Show inactive"
                                />
                                <Link className="create__btn" to="/external/create">Add External User</Link>
                            </div>

                            <DataTable 
                                cols={cols} 
                                rows={this.props.users.externalUsers}
                                rowClickAction={user => this.editExternal(user.Username)}
                            ></DataTable>
                        </section>
                    : null}
                </TabPanel>

                
            </div>
        )
    }
}

const mapStateToProps = (state: AppState) => ({
    users: state.users,
    loadUsers: loadUsers,
    loadExternal: loadExternal
});

export default withRouter(
    connect(mapStateToProps, {
        loadUsers,
        loadExternal
    })(Users)
);